<template lang="pug">
  el-container(v-if="form", id="patient-info-form")
    .fixedFloatBar
      el-button(plain, @click="clickCancel").cancel-button ยกเลิก
      el-button(type="primary", @click="clickSave", :disabled="disabledButton") บันทึก
    el-main.container
      el-form.form(ref="form", :model="form", :rules="rules", label-width="270px")
        el-row
          .header-22-black.head ข้อมูลผู้ติดต่อ
        el-form-item(prop="contact.name", style="margin-top: 30px;")
          span(slot="label")
            span.require-star *
            span.label ชื่อผู้ติดต่อ
          el-input(v-model="form.contact.name")
        el-form-item(prop="contact.phone")
          span(slot="label")
            span.require-star *
            span.label เบอร์โทร
          el-input(v-model="form.contact.phone")
        el-form-item(prop="contact.email")
          span.label(slot="label") อีเมล
          el-input(v-model="form.contact.email")
        el-form-item
          span(slot="label")
            span.require-star *
            span.label ประเภทลูกค้า

          el-radio-group(v-model="form.customerType", :disabled="!form.canEditCustomerType").group-vertical.radio
            el-radio(label="general") ลูกค้าทั่วไป
            el-radio(label="company") ลูกค้าบริษัท
              el-form-item
                el-radio-group(v-model="form.customerCompany.preset", :disabled="!form.canEditCustomerType", v-if="form.customerType === 'company'", style="margin-left:20px;margin-top:16px;display:flex;flex-direction:column;")
                  el-radio(label="MTL") บริษัท MTL
                  el-radio(label="other") บริษัทอื่น ๆ
        div(v-show="form.customerType === 'company' && form.customerCompany.preset === 'other'", style="margin-left: 20px; margin-top: 16px;")
          el-form-item
            span(slot="label")
              span.require-star *
              span.label ชื่อบริษัท
            el-input(v-model="form.customerCompany.name")
          el-form-item(prop="customerCompany.taxId", class="tax-form")
            span(slot="label")
              span.require-star *
              span.label เลขประจำตัวผู้เสียภาษี
            el-input(v-model="form.customerCompany.taxId", maxlength="13")
          el-form-item(prop="customerCompany.branch", class="tax-form")
            span(slot="label")
              span.require-star *
              span.label สำนักงาน/สาขาเลขที่
            el-input(v-model="form.customerCompany.branch")
          el-form-item(style="margin-top:16px;")
            span(slot="label")
              span.require-star *
              span.label ที่อยู่สำหรับการออกใบกำกับภาษี
            el-input(type="textarea", :rows="3", v-model="form.customerCompany.address")
          el-form-item(prop="customerCompany.email", class="tax-form")
            span(slot="label")
              span.require-star *
              span.label อีเมลสำหรับการรับใบกำกับภาษี
            el-input(v-model="form.customerCompany.email")
          el-form-item(style="margin-top:16px;")
            span(slot="label")
              span.require-star *
              span.label ที่อยู่สำหรับการรับเอกสารทางไปรษณีย์
            div(style="display: flex; flex-direction: row; width: 100%;")
              el-checkbox-group(v-model="form.hasSameAddress", style="width: 100%;").group-vertical
                el-checkbox(label="hasSameAddress", @click="() => form.customerCompany.mailAddress = ''") ใช้ที่อยู่เดียวกับที่อยู่ในใบกำกับภาษี
                el-input(type="textarea", :rows="3", v-model="form.customerCompany.mailAddress", :disabled="form.hasSameAddress")

        el-row(style="margin-top: 100px;")
          .header-22-black.head ข้อมูลคนไข้
        el-form-item(style="margin-top: 30px;")
          span(slot="label")
            span.require-star *
            span.label ชื่อคนไข้
          el-input(v-model="form.name")
        el-form-item
          span(slot="label")
            i.el-icon-mobile-phone
            span.require-star *
            span.label เพศ
          el-radio-group(v-model="form.gender").group-vertical.radio
            el-radio(label="male") ชาย
            el-radio(label="female") หญิง
        el-form-item(prop="age")
          span(slot="label")
            i.el-icon-mobile-phone
            span.require-star *
            span.label อายุ
          el-input(v-model.number="form.age", maxlength="3")
        el-form-item(prop="weight")
          span(slot="label")
            i.el-icon-mobile-phone
            span.require-star *
            span.label น้ำหนัก
          el-select(v-model="form.weight", placeholder="เลือกนํ้าหนัก")
            el-option(v-for="w in weight" :label="w.label" :value="w.value" :key="'weight-' + w.value")
          span.label.unit กก.
        el-form-item(prop="height")
          span(slot="label")
            i.el-icon-mobile-phone
            span.require-star *
            span.label ส่วนสูง
          el-select(v-model="form.height", placeholder="เลือกส่วนสูง")
            el-option(v-for="h in height" :label="h.label" :value="h.value" :key="'height-' + h.value")
          span.label.unit ซม.
        el-form-item
          span(slot="label")
            i.el-icon-mobile-phone
            span.require-star *
            span.label สภาพคนไข้
          el-radio-group(v-model.number="form.type").group-vertical.radio
            el-radio(:label="1") 1. คนไข้ช่วยเหลือตัวเองได้ปกติ (ไม่ต้องพยุง)
            el-radio(:label="2") 2. คนไข้ช่วยเหลือตัวเองได้น้อย (ต้องช่วยพยุง)
            el-radio(:label="3") 3. คนไข้ช่วยเหลือตัวเองได้น้อย (ติดเตียง)
        el-form-item
          span(slot="label")
            i.el-icon-mobile-phone
            span.require-star *
            span.label โรค
          radioYesNoInput(:radioValue.sync="form.hasDiseases", vertical="true", yesWord="มีโรค", noWord="ไม่มีโรค")

          div(v-show="form.hasDiseases", style="margin-left: 20px; margin-top: 10px;")
            diseaseCheckbox(label="hypertension", :diseases.sync="form.diseases") ความดันโลหิตสูง
            diseaseCheckbox(label="postOperation", :diseases.sync="form.diseases") หลังผ่าตัด
            diseaseCheckbox(label="stroke", :diseases.sync="form.diseases") อัมพฤกษ์ / อัมพาต
            diseaseCheckbox(label="diabetes", :diseases.sync="form.diseases") เบาหวาน
            diseaseCheckbox(label="cancer", :diseases.sync="form.diseases") มะเร็ง
            diseaseCheckbox(label="parkinson", :diseases.sync="form.diseases") พาร์กินสัน
            diseaseCheckbox(label="arthrosis", :diseases.sync="form.diseases") ข้อเข่าเสื่อม
            diseaseCheckbox(label="alzheimer", :diseases.sync="form.diseases") อัลไซเมอร์
            diseaseCheckbox(label="kidneyFailure", :diseases.sync="form.diseases") โรคไต
            diseaseCheckbox(label="psychiatric", :diseases.sync="form.diseases") จิตเวช
            diseaseCheckbox(label="other", :diseases.sync="form.diseases") อื่นๆ

        el-form-item
          span(slot="label")
            i.el-icon-mobile-phone
            span.require-star *
            span.label กิจกรรมที่อาศัยทักษะ
          el-checkbox-group(v-model="form.skills").group-vertical
            div.text ทักษะทั่วไป
            el-checkbox(label="vitalSign") วัดสัญญาณชีพ
            el-checkbox(label="transferring") เคลื่อนย้ายคนไข้
            el-checkbox(label="basicPhysicalTherapy") กายภาพเบื้องต้น
            el-checkbox(label="enema") สวนอุจจาระ
            el-checkbox(label="bedBath") เช็ดตัวบนเตียง
            el-checkbox(label="feedingNose") ฟีด ทางจมูก
            el-checkbox(label="feedingStomach") ฟีด ทางหน้าท้อง
            el-checkbox(label="suctionOral") ซัคชัน ปาก
            el-checkbox(label="suctionTracheostomy") ซัคชัน เจาะคอ
            el-checkbox(label="retainedCatheterization") ดูแลสายสวนปัสสาวะคา (เทฉี่)
            el-checkbox(label="bloodSugar") เจาะนํ้าตาล
            div(style="display: flex; flex-direction: row; justify-content: space-between; align-items: baseline; width: 100%;")
              el-col(:span="11")
                div
                  el-checkbox(label="injection", v-on:change="changeCheckboxInjection") ฉีดยาใต้ผิวหนัง
              el-col(:span="12")
                el-input(v-model="form.skillOptions.injection.detail", :disabled="!form.skills.includes('injection')", style="width: 100%;", placeholder="ประเภทยา")
            div.text(style="margin-top: 8px;") ทักษะอื่น ๆ
            el-checkbox(label="intermittentCatheterization") สวนปัสสาวะทิ้ง
            el-checkbox(label="colostomy") ดูแลถุงหน้าท้อง
            el-checkbox(label="woundCare") ทำแผล
            el-row(style="padding-left: 16px;")
              el-radio-group(v-model="form.skillOptions.woundCare.level", v-if="form.skills.includes('woundCare')", style="margin-bottom: 4px;").group-vertical
                el-radio(:label="1") แผลระดับ 1
                el-radio(:label="2") แผลระดับ 2
                el-radio(:label="3") แผลระดับ 3
                el-radio(:label="4") แผลระดับ 4
        el-form-item(style="margin-top: 60px;")
          span(slot="label")
            i.el-icon-mobile-phone
            span.require-star *
            span.label กิจกรรมทั่วไป
          radioYesNoInput(:radioValue.sync="form.activity.preparingFood") ทำอาหารปั่นให้ผู้ป่วย

        el-form-item
          span(slot="label")
            i.el-icon-mobile-phone
            span.require-star *
            span.label สิ่งแวดล้อมที่บ้านคนไข้
          radioYesNoCheckbox(:petValid.sync="form.environment.petValid"
            :checkboxValue.sync="form.environment.pet") สัตว์เลี้ยงในบ้าน

        el-form-item
          span(slot="label")
            i.el-icon-mobile-phone
            span.label สิ่งที่คุณหมอให้เฝ้าระวังเป็นพิเศษ
          el-input(type="textarea", :rows="3", v-model="form.doctorNote")

        el-form-item
          span(slot="label")
            span.label เรื่องอื่น ๆ
          p(v-if="form.patientNote", style="font-size: 18px; color: #A2A7B3; margin-bottom: 8px;") ลูกค้า : {{ form.patientNote }}
          p(style="font-size: 18px; color: #A2A7B3; margin-bottom: 8px;")
            i.el-icon-mobile-phone
            span แอดมิน :
          el-input(type="textarea", :rows="3", v-model="form.caregiverNote", placeholder="เช่น  สิ่งที่คนไข้ชอบ หรือ ไม่ชอบให้ทํา")

        el-form-item
          span(slot="label")
            span.label แอดมินโน้ต
          el-input(type="textarea", :rows="3", v-model="form.note")
</template>

<style lang="scss" scoped>
  $float-bar: 1000;

  .text {
    color: #A2A7B2;
    font-size: 18px;
    font-weight: 400;
    line-height: 2.2;
  }

  .el-button {
    margin: 10px;
    width: 120px;
  }

  .container {
    padding-top: 155px;
  }

  .fixedFloatBar {
    z-index: $float-bar;
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0px;
    background-color: white;
    padding: 10px;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .form {
    width: 95%;
  }

  .el-radio+.el-radio {
    margin-left: 0px;
    margin-top: 15px;
  }

  .el-checkbox+.el-checkbox {
    margin-left: 0px;
  }

  i {
    margin-right: 5px;
    color: #dcdfe6;
    font-size: 20px;
  }

  .el-input {
    width: 60%;
    &.short {
      width: 50%
    }
  }

  .group-horizontal {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    &.input-checkbox {
      margin-bottom: 10px;
      width: 400px;
      &.extended {
        width: 600px;
      }
    }
    &.radio-input {
      margin-top: 5px;
      height: 30px;
    }
    &.area {
      width: 400px;
      height: 50px;
    }
  }

  .group-vertical {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    &.radio {
      margin-top: 12px;
      margin-left: 0px;
      font-size: 16px;
    }
  }

  .disease-container {
    margin-top: 10px;
    margin-left: 20px;
  }

  .extra-label-radio {
    width: 50px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: -25px;
  }

  span.label {
    font-family: 'Sukhumvit-Bold';
    color: #303133;
    font-size: 18px;
    font-weight: 600;
  }

  span.label.unit {
    margin-left: 16px;
    font-family: 'Sukhumvit-Medium';
    font-size: 18px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #b0b3b8;
  }

  .head {
    font-family: 'Sukhumvit-Bold';
    text-align: right;
    width: 260px;
  }

  .tax-form {
    margin-top: 16px;
  }

  .el-select {
    width: 30%;
  }

  .el-form-item__label {
    padding-right: 22px !important;
  }

  .require-star {
    font-family: 'Sukhumvit';
    font-size: 18px;
    font-weight: normal;
    color: #C0C4CC;
    margin-right: 4px;
  }
</style>

<script>
import diseaseCheckbox from './DiseaseCheckbox'
import radioYesNoCheckbox from './RadioYesNoCheckbox'
import radioSelectionInput from './RadioSelectionInput'
import radioYesNoInput from './RadioYesNoInput'
import PatientModel from '@/model/PatientModel'

export default {
  name: 'PatientInfoForm',
  components: {
    diseaseCheckbox,
    radioYesNoCheckbox,
    radioSelectionInput,
    radioYesNoInput,
  },
  mounted () {
    this.getProvinces()
  },
  watch: {
    formData (formData, oldFormData) {
      this.form = formData
      this.form.hasDiseases = formData.diseases.length > 0
    },
    hasSameAddress (mailAddress, oldFormData) {
      if (mailAddress) {
        this.form.customerCompany.mailAddress = ''
      }
    },
  },
  props: {
    formData: {
      type: Object,
      required: false,
    },
  },
  computed: {
    hasSameAddress () {
      return this.form.hasSameAddress
    },
    disabledButton () {
      let form = this.form
      let notContact = !form.contact.name || !form.contact.phone
      let noPatient = !form.name || !form.gender || form.age === 0 || form.weight === 0 || form.height === 0 || !form.type || form.hasDiseases === null || form.skills.length === 0 || form.activity.preparingFood === null || form.environment.petValid === null
      let otherCompany = form.customerType === 'company' && form.customerCompany.preset === 'other' && form.customerCompany.name !== '' && form.customerCompany.branch !== '' && form.customerCompany.address !== '' && form.customerCompany.email !== '' && form.customerCompany.taxId !== ''

      let noCustomerType = !((form.customerType === 'general') || (form.customerType === 'company' && form.customerCompany.preset === 'MTL') || otherCompany)
      let isHasSameAddress = form.customerType === 'company' && form.customerCompany.preset === 'other' && !form.hasSameAddress && form.customerCompany.mailAddress === ''

      let psychiatric = form.diseases.find(disease => disease.name === 'psychiatric')
      let noPsychiatricSevere = false
      if (psychiatric !== undefined && psychiatric.severe === null) {
        noPsychiatricSevere = true
      }

      let alzheimer = form.diseases.find(disease => disease.name === 'alzheimer')
      let noAlzheimerSevere = false
      if (alzheimer !== undefined && alzheimer.severe === null) {
        noAlzheimerSevere = true
      }

      return notContact || noPatient || noCustomerType || noPsychiatricSevere || noAlzheimerSevere || isHasSameAddress
    },
  },
  methods: {
    async getProvinces () {
      try {
        let res = await this.$api.Resource.provinces()
        this.provinces = [...res.result.provinces]
          .map((province) => ({
            value: province,
            label: province,
          }))
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    validateSendData () {
      if (!this.form.skills.includes('woundCare')) this.form.skillOptions.woundCare.level = 0
      if (!this.form.skills.includes('injection')) this.form.skillOptions.injection.detail = ''
      if (!this.form.hasDiseases) this.form.diseases = []
      if (this.form.customerType !== 'company') {
        this.form.customerCompany.name = ''
        this.form.customerCompany.branch = ''
        this.form.customerCompany.address = ''
        this.form.customerCompany.email = ''
        this.form.customerCompany.mailAddress = ''
        this.form.customerCompany.taxId = ''
        this.form.customerCompany.preset = ''
        this.form.hasSameAddress = true
      }
      if (this.form.customerCompany.preset !== 'other') {
        this.form.customerCompany.name = ''
        this.form.customerCompany.branch = ''
        this.form.customerCompany.address = ''
        this.form.customerCompany.email = ''
        this.form.customerCompany.mailAddress = ''
        this.form.customerCompany.taxId = ''
        this.form.hasSameAddress = true
      }
    },
    clickSave () {
      this.validateSendData()
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('save', this.form)
        } else {
          this.$alert('ไม่สามารถบันทึก กรุณากรอกข้อมูลให้ถูกต้อง', '', {
            confirmButtonText: 'โอเค',
            showClose: false,
            type: 'error',
          })
        }
      })
    },
    clickCancel () {
      this.$emit('cancel')
    },
    changeCheckboxInjection (state) {
      if (!state) {
        this.form.skillOptions.injection.detail = ''
      }
    },
  },
  data () {
    return {
      rawHospital: [],
      provinces: [],
      districts: [],
      subdistricts: [],
      timeout: null,
      results: [],
      form: PatientModel.createWithDefaultSkill(),
      weight: [
        { value: '<31', label: 'น้อยกว่า 31' },
        { value: '31-40', label: '31-40' },
        { value: '41-50', label: '41-50' },
        { value: '51-60', label: '51-60' },
        { value: '61-70', label: '61-70' },
        { value: '71-80', label: '71-80' },
        { value: '81-90', label: '81-90' },
        { value: '91-100', label: '91-100' },
        { value: '101-110', label: '101-110' },
        { value: '111-120', label: '111-120' },
        { value: '>120', label: 'มากกว่า 120' },
      ],
      height: [
        { value: '<121', label: 'น้อยกว่า 121' },
        { value: '121-130', label: '121-130' },
        { value: '131-140', label: '131-140' },
        { value: '141-150', label: '141-150' },
        { value: '151-160', label: '151-160' },
        { value: '161-170', label: '161-170' },
        { value: '171-180', label: '171-180' },
        { value: '181-190', label: '181-190' },
        { value: '>190', label: 'มากกว่า 190' },
      ],
      rules: {
        contact: {
          phone: [
            { required: false, pattern: '^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$', message: 'กรุณากรอกตัวเลข 10 หลัก', trigger: 'blur' },
          ],
          email: [
            { required: false, type: 'email', trigger: 'blur', message: 'กรุณากรอกอีเมลให้ถูกต้อง' },
          ],
        },
        age: [
          { required: false, type: 'number', min: 1, max: 200, message: 'กรุณากรอกตัวเลข 1-200', trigger: 'blur' },
        ],
        customerCompany: {
          email: [
            { required: false, type: 'email', trigger: 'blur', message: 'กรุณากรอกอีเมลให้ถูกต้อง' },
          ],
          taxId: [
            { required: false, pattern: '^[0-9]{13}$', message: 'กรุณากรอกตัวเลข 13 หลัก', trigger: 'blur' },
          ],
        },
      },
    }
  },
}
</script>
